module.exports = __webpack_public_path__ + "static/media/icon-unified-media.d5c51cfa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/WorkBar/icon-unified-media.svg
// module id = 1868
// module chunks = 0